import React, { useEffect, useState } from "react";
import { getWidgetInstallationKey } from "../services/settingsService";

export default function WidgetInstallationKey() {
  const [record, setRecord] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [copyStatus, setCopyStatus] = useState("");

  useEffect(() => {
    let active = true;
    getWidgetInstallationKey().then((value) => { if (active) setRecord(value); })
      .catch((err) => { if (active) setError(err.message || "Unable to load the installation key."); })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, []);

  const copyKey = async () => {
    if (!record?.key) return;
    try {
      if (!navigator.clipboard?.writeText) throw new Error("Clipboard access is unavailable in this browser.");
      await navigator.clipboard.writeText(record.key);
      setCopyStatus("Installation key copied.");
    } catch (err) { setCopyStatus(err.message || "Unable to copy the key."); }
  };

  return <div className="card p-4">
    <h2 className="h5">Widget installation key</h2>
    <p className="text-muted">Use this identifier when configuring the website widget snippet.</p>
    {loading ? <div className="py-3" role="status"><span className="spinner-border spinner-border-sm me-2"/>Loading installation key…</div>
      : error ? <div className="alert alert-danger" role="alert">{error}</div>
      : <>
        <div className="d-flex align-items-center gap-2 mb-3"><span className={`badge ${record.isDemo ? "text-bg-warning" : "text-bg-success"}`}>{record.isDemo ? "Demo key" : "Configured key"}</span></div>
        <div className="input-group"><input className="form-control font-monospace" readOnly value={record.key} aria-label="Widget installation key"/><button className="btn btn-outline-secondary" type="button" onClick={copyKey}><i className="bi bi-clipboard me-1"/>Copy key</button></div>
        {copyStatus && <div className="small mt-2" role="status">{copyStatus}</div>}
        {record.isDemo && <p className="small text-muted mt-3 mb-0">This is a non-production demo identifier. A unique key must be provisioned by the backend for each workspace before deployment.</p>}
      </>}
  </div>;
}
